import { createReducer, createActions } from 'reduxsauce'
import Immutable from 'seamless-immutable'

/* ------------- Types and Action Creators ------------- */

const { Types, Creators } = createActions({
    editCadreRequest: ['response'],
    editCadreSuccess: ['loading', 'response'],
    editCadreFailure: ['error'],
})

export const editCadreTypes = Types
export default Creators

/* ------------- Initial State ------------- */

export const INITIAL_STATE = Immutable({
    response: null,
    success: null,
    error: null,
})

/* ------------- Reducers ------------- */

const editCadreRequest = state => state.merge({ success: null })

const editCadreSuccess = (state, { response }) =>
    state.merge({
        success: true,
        error: false,
        response,
    })

const editCadreFailure = (state, { error }) => {
    const { response } = error
    return state.merge({
        success: false,
        error: true,
        response,
    })
}

export const reducer = createReducer(INITIAL_STATE, {
    [Types.EDIT_CADRE_REQUEST]: editCadreRequest,
    [Types.EDIT_CADRE_SUCCESS]: editCadreSuccess,
    [Types.EDIT_CADRE_FAILURE]: editCadreFailure,
})
